import React from 'react';
import axios from 'axios';
import { ButtonGroup, Button, Modal, Glyphicon, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import AddZlecenieModal from './AddZlecenie';
import UpdateZlecenieModal from './UpdateZlecenie';
import WydrukKlientModal from './WydrukKlient';
import WydrukMagazynModal from './WydrukMagazyn';
import { login, logout, isLoggedIn} from '../../utils/AuthService';

var Zlecenia = React.createClass({

	getInitialState: function() {
		return {
			data: null,
			selectedZlecenieId: null,
			showAddModal: false,
			showUpdateModal: false,
			showWydrukKlientModal: false,
			showWydrukMagazynModal: false
		}
    },

	componentDidMount: function() {
		this.refreshTable();
	},

	render: function() {

		var selectRowProp = {
			mode: "radio",
			clickToSelect: true,
			className: "selected-row",
			bgColor: 'rgb(101, 148, 255)',
			onSelect: this.onRowSelect
		};

		if(!isLoggedIn()){
			return (<div></div>);
		};

		return (
			<div>
				<div className="row">
					<div className="col-sm-5">
						<ButtonGroup className="m-10">
							<Button bsStyle="primary" onClick={this.openAddModal}><Glyphicon glyph="plus" /> Dodaj zlecenie</Button>
							<Button bsStyle="warning" disabled={this.state.selectedZlecenieId === null} onClick={this.openUpdateModal}><Glyphicon glyph="refresh" /> Aktualizuj</Button>
							<Button bsStyle="danger" disabled={this.state.selectedZlecenieId === null} onClick={this.onDeleteBtnClicked}><Glyphicon glyph="trash" /> Usuń</Button>
						</ButtonGroup>
					</div>
					<div className="col-sm-7">
						<ButtonGroup className="m-10">
							<Button bsStyle="primary" disabled={this.state.selectedZlecenieId === null} onClick={this.openWydrukKlientModal}><Glyphicon glyph="print" /> Drukuj - klient</Button>
							<Button bsStyle="primary" disabled={this.state.selectedZlecenieId === null} onClick={this.openWydrukMagazynModal}><Glyphicon glyph="print" /> Drukuj - magazyn</Button>
						</ButtonGroup>
					</div>
				</div>


				<BootstrapTable data={this.state.data}
					striped={true}
					hover={true}
					pagination={true}
					search={true}
					selectRow={selectRowProp}>
						<TableHeaderColumn dataField="id" isKey={true} dataSort={true}>ID</TableHeaderColumn>
						<TableHeaderColumn dataField="imie" dataSort={true}>Imię</TableHeaderColumn>
						<TableHeaderColumn dataField="nazwisko" dataSort={true}>Nazwisko</TableHeaderColumn>
						<TableHeaderColumn dataField="telefon" dataSort={true}>Telefon</TableHeaderColumn>
						<TableHeaderColumn dataField="numerListwy" dataSort={true}>Nr Listwy</TableHeaderColumn>
					  <TableHeaderColumn dataField="cena" dataSort={true}>Cena</TableHeaderColumn>
						<TableHeaderColumn dataField="zaliczka" dataSort={true}>Zaliczka</TableHeaderColumn>
						<TableHeaderColumn dataField="pozostalaDoplata" dataSort={true}>Doplata</TableHeaderColumn>
						<TableHeaderColumn dataField="uwagi" dataSort={true}>Uwagi</TableHeaderColumn>
						<TableHeaderColumn dataField="czyZrealizowane" dataSort={true}>Zrealizowane</TableHeaderColumn>
				</BootstrapTable>

				<Button bsStyle="success" disabled={this.state.selectedZlecenieId === null} onClick={this.onZrealizowaneBtnClicked}><Glyphicon glyph="ok" /> Oznacz jako zrealizowane</Button>

				<AddZlecenieModal parent={this} ref="addZlecenie" />
				<UpdateZlecenieModal parent={this} ref="updateZlecenie"/>
				<WydrukKlientModal parent={this} ref="wydrukKlient"/>
				<WydrukMagazynModal parent={this} ref="wydrukMagazyn"/>

			</div>
		);
	},

	onRowSelect: function(row, isSelected) {
		if(isSelected) {
			this.setState({ selectedZlecenieId: row.id });
		}else {
			this.setState({ selectedZlecenieId: null });
		}
	},

	closeAddModal: function() {
		this.setState({ showAddModal: false });
		this.refs.addZlecenie.clearAddObject();
	},

	openAddModal: function() {
		this.refs.addZlecenie.clearAddObject();
		this.setState({ showAddModal: true });
	},

	closeUpdateModal: function() {
		this.setState({showUpdateModal: false});
		this.refs.updateZlecenie.clearUpdateObject();
	},

	openUpdateModal: function() {
		this.refs.updateZlecenie.fillUpdateObject();
		this.setState({showUpdateModal: true});
	},

	closeWydrukKlientModal: function() {
		this.setState({showWydrukKlientModal: false});
		this.refs.wydrukKlient.clearWydrukKlientObject();
	},

	openWydrukKlientModal: function() {
		this.refs.wydrukKlient.fillWydrukKlientObject();
		this.setState({showWydrukKlientModal: true});
	},

	closeWydrukMagazynModal: function() {
		this.setState({showWydrukMagazynModal: false});
		this.refs.wydrukMagazyn.clearWydrukMagazynObject();
	},

	openWydrukMagazynModal: function() {
		this.refs.wydrukMagazyn.fillWydrukMagazynObject();
		this.setState({showWydrukMagazynModal: true});
	},

	onDeleteBtnClicked: function() {
		axios.delete('http://217.182.200.222:8080/zlecenie/' + this.state.selectedZlecenieId)
			.then(function (response) {
				this.refreshTable();
			}.bind(this))
			.catch(function (error) {
				alert("Błąd przy usuwaniu zlecenia");
				console.log(error);
			});
	},

	getZlecenieById: function(id) {
		for(var i in this.state.data) {
			if(this.state.data[i].id === id) {
				return this.state.data[i];
			}
		}
		return '';
	},

	onZrealizowaneBtnClicked: function() {
		axios.put('http://217.182.200.222:8080/zlecenieZrealizowane/' + this.state.selectedZlecenieId)
			.then(function (response) {
				this.refreshTable();
			}.bind(this))
			.catch(function (error) {
				alert("Błąd przy oznaczaniu jako zrealizowane");
				console.log(error);
			});
	},


// WYDRUKI PDF Z SERWERA
	// onWydrukKlientBtnClicked: function() {
	// 	axios.put('http://217.182.200.222:8080/zlecenieWydrukKlient/' + this.state.selectedZlecenieId)
	// 		.then(function (response) {
	// 			this.refreshTable();
	// 		}.bind(this))
	// 		.catch(function (error) {
	// 			alert("Błąd przy generowaniu wydruku");
	// 			console.log(error);
	// 		});
	// },
	//
	// onWydrukMagazynBtnClicked: function() {
	// 	axios.get('http://217.182.200.222:8080/zlecenieWydrukMagazyn/' + this.state.selectedZlecenieId)
	// 		.then(function (response) {
	// 			this.pdf = response;
	// 			console.log(this.pdf);
	// 			this.openWydrukMagazynModal();
	// 		}.bind(this))
	// 		.catch(function (error) {
	// 			alert("Błąd przy generowaniu wydruku");
	// 			console.log(error);
	// 		});
	// },

	refreshTable: function() {
		axios.get('http://217.182.200.222:8080/zlecenie')
		.then(function (zlecenia) {
			this.setState({data: zlecenia.data});
		}.bind(this));
	}
});

export default Zlecenia;



// WEBPACK FOOTER //
// ./src/components/Zlecenie/Zlecenia.js